import { ArdoqId } from '@ardoq/api-types';
import { colors } from '@ardoq/design-tokens';
import { PointAndAngle } from '@ardoq/graph';
import styled from 'styled-components';
import { ICON_RADIUS } from '../consts';
import { ComponentDetails } from '../types';

type ComponentIconCirclesProps = {
  components: ComponentDetails[];
  highlightedComponentId: ArdoqId | null;
  componentIdInContext: ArdoqId | null;
  componentsWithReferencesToHighlightedComponent: ArdoqId[];
  componentPositions: Map<ComponentDetails, PointAndAngle>;
};

export const ComponentIconCircles = ({
  components,
  highlightedComponentId,
  componentIdInContext,
  componentsWithReferencesToHighlightedComponent,
  componentPositions,
}: ComponentIconCirclesProps) => {
  const componentIconCircles = components.map(component => {
    const [x, y] = componentPositions.get(component)!;
    return (
      <ComponentIconCircle
        key={component.id}
        x={x}
        y={y}
        component={component}
        isSetInContext={componentIdInContext === component.id}
        isHighlighted={component.id === highlightedComponentId}
        isOutOfHighlight={
          !componentsWithReferencesToHighlightedComponent.includes(component.id)
        }
      />
    );
  });

  return <>{componentIconCircles}</>;
};

type ComponentIconCircleProps = {
  component: ComponentDetails;
  isHighlighted: boolean;
  isSetInContext: boolean;
  isOutOfHighlight: boolean;
  x: number;
  y: number;
};

const ComponentIconCircle = ({
  component,
  isHighlighted,
  isSetInContext,
  isOutOfHighlight,
  x,
  y,
}: ComponentIconCircleProps) => {
  return (
    <g
      transform={`translate(${x}, ${y})`}
      opacity={isOutOfHighlight ? 0.75 : 1}
    >
      {(isHighlighted || isSetInContext) && (
        <HighlightCircle
          cx={0}
          cy={0}
          r={ICON_RADIUS + 5}
          stroke={
            isSetInContext
              ? colors.blue400
              : (component.color ?? colors.blue400)
          }
        />
      )}
      <IconCircle
        fill={component.backgroundColor ?? colors.white950}
        stroke={component.color ?? colors.black950}
        cx={0}
        cy={0}
        r={ICON_RADIUS}
      />
    </g>
  );
};
const IconCircle = styled.circle`
  stroke-width: 1;
  pointer-events: stroke;
  cursor: pointer;
`;

const HighlightCircle = styled.circle`
  stroke-width: 3;
  fill: ${colors.transparent0};
  pointer-events: fill;
  cursor: pointer;
`;
